import { axiosAuthApi } from "services/api";

// API call to get brands based on filter
export const getBrands = async (header, formData, page) => {
    try {
      const response = await axiosAuthApi(header).post(`/brands/filter?page=${page}`, formData);
      return response;
    } catch (error) {
      throw error; // Throw error to be handled in the action
    }
  };